/*
 * Import modules from components of ES6
 * 
 *        
 */
import '@uixkit/core/_app-load';